var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defaultRendererConfig, setupBingAerialImagery } from "./index";
import { sceneFlyover } from "./utils/sceneFlyover";
export function meshTilesetFlyover1(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        description.innerHTML =
            "<h1>" +
                "Mesh Tileset Flyover 1" +
                "</h1>" +
                "<p>" +
                "The camera will fly over a mesh tileset. The tileset should render normally." +
                "</p>";
        const initialWait = 5;
        const time = 2;
        const durations = [0, initialWait, time, time, time, time, time, time, time, time];
        const positions = [
            { longitude: 2.6303203957720878, latitude: -0.6130562882478694, height: 15.366232959763943 },
            { longitude: 2.6303203957720878, latitude: -0.6130562882478694, height: 15.366232959763943 },
            { longitude: 2.630330402990091, latitude: -0.6130562458592583, height: 18.350279476699136 },
            { longitude: 2.6303318184663076, latitude: -0.6130643172308671, height: 13.648949810817482 },
            { longitude: 2.630322178701012, latitude: -0.6130633323834219, height: 31.46967085783379 },
            { longitude: 2.630325887440997, latitude: -0.613060145686273, height: 12.137733689808417 },
            { longitude: 2.6303225689957084, latitude: -0.6130585920305031, height: 5.277597705712038 },
            { longitude: 2.630322854589889, latitude: -0.6130585531258915, height: 5.453306714032032 },
            { longitude: 2.6303231569673007, latitude: -0.6130586320287303, height: 5.45798587740705 },
            { longitude: 2.630324477568678, latitude: -0.6130596386020373, height: 6.080866994895543 },
        ];
        const focuses = [
            { longitude: 2.6303269120874644, latitude: -0.6130593021328782, height: 10.461219210003126 },
            { longitude: 2.6303269120874644, latitude: -0.6130593021328782, height: 10.461219210003126 },
            { longitude: 2.6303296840338755, latitude: -0.6130571208930321, height: 16.164262276017755 },
            { longitude: 2.630329408426022, latitude: -0.6130626798346483, height: 6.2029420447089745 },
            { longitude: 2.6303269120874644, latitude: -0.6130593021328782, height: 10.461219210003126 },
            { longitude: 2.6303269120874644, latitude: -0.6130593021328782, height: 10.461219210003126 },
            { longitude: 2.6303269120874644, latitude: -0.6130593021328782, height: 10.461219210003126 },
            { longitude: 2.6303220670001517, latitude: -0.6130583723605392, height: 4.751185019808298 },
            { longitude: 2.630324984437315, latitude: -0.6130598986211112, height: 5.700414700719323 },
            { longitude: 2.630324984437315, latitude: -0.6130598986211112, height: 5.700414700719323 },
        ];
        yield sceneFlyover(defaultRendererConfig(container), durations, positions, focuses, (renderer) => __awaiter(this, void 0, void 0, function* () {
            // Scene setup
            setupBingAerialImagery(renderer);
            const object = yield renderer.getObjectFactory().createTileset({
                type: "direct",
                url: "https://s3.ap-southeast-2.amazonaws.com/skand.production.sites/5f2792e85f586c001de0a728/62b8f3e721218a004eaf06b8/62b8f3ed42eb3e004d31152a/Files/Tileset3d/62b920af0e0860004e518599/Scene/Production_1.json",
            });
            object.setPositionECEF([0, 0, -100]);
            renderer.getWorld().addObject(object);
        }));
    });
}
